// Lab page translations
const labTranslations = {
  en: {
    hero: {
      eyebrow: "lab / thewhizkind",
      title: "the <span>lab</span>",
      intro: [
        "things we've built with people, teams & organisations.",
        "some solve very specific problems. some automate things that shouldn't be done by hand. some started simply because we wondered, could this work?",
        "some are public. some aren't.",
        "some we play with. some our partners actually work with."
      ]
    },
    transition: "experiments / tools / systems / 01—∞",
    invite: {
      text: "curious about one? get in touch and we'll give you something to play with.",
      link: ["these experiments sit alongside our","services."]
    },
    index: {
      label: "things we've made.",
      mark: "+"
    },
    tools: {
      argus: {
        name: "argus",
        category: "internal tool / data / automation",
        status: "active",
        oneLiner: "built around a specific workflow, turning real-world data into something easier to understand, manage and act on.",
        detail: "every month someone was reconciling a claim spreadsheet against a stack of debit-note documents by hand — matching numbers, chasing mismatches, hunting for what didn't add up. argus reads the documents, matches them against the register line by line, and hands the same file back with every row checked. built to watch one real, messy workflow closely enough to trust it.",
        tags: ["React", "Node.js", "PostgreSQL", "Claude AI", "Document Extraction"]
      },
      proba: {
        name: "proba",
        category: "education / assessment / dashboard",
        status: "active",
        oneLiner: "a platform to take tests on, with every response landing straight into a live, interactive dashboard.",
        detail: "a timed, structured test in the browser — sections graded automatically where the answer is clear-cut, flagged for a human where it isn't. every submission writes straight into a dashboard built for scanning, filtering and scoring, so whoever's grading sees results as they come in instead of a stack of paper afterwards.",
        tags: ["React", "Vite", "Dashboards", "Auto-Scoring"]
      },
      fero: {
        name: "fero",
        category: "crm / finance / operations",
        status: "active",
        oneLiner: "a crm and finance tool built as one platform — finances, employees, contracts and sales, together.",
        detail: "the parts of running a small company that usually live in five different tools and none of them talk to each other. invoicing and cash flow next to contracts, next to the people on payroll, next to the sales pipeline — one place, one source of truth. built the way we build most things: around what a small team actually needs, not what a big one might.",
        tags: ["CRM", "Finance", "Contracts", "HR", "Sales"]
      },
      atlas: {
        name: "atlas",
        category: "internal tool / lead generation / automation",
        status: "active",
        oneLiner: "an internal system for finding what might be worth our attention.",
        detail: "atlas was built around a simple problem: there are more opportunities out there than anyone has time to look for. it does some of that looking for us, bringing the interesting ones closer and leaving the rest behind.",
        tags: ["Node.js", "PostgreSQL", "Claude AI", "Automation", "Lead Generation"]
      },
      vex: {
        name: "vex",
        category: "ai / personalised",
        status: "active",
        oneLiner: "our own ai, shaped around whoever's actually using it.",
        detail: "most ai tools hand everyone the same assistant. vex is built to be trained on a person's or a company's own data, so it knows the context instead of guessing at it — personalised to the way someone actually works. the part of the lab we're most excited about right now.",
        tags: ["AI", "Personalisation"]
      },
      nyx: {
        name: "nyx",
        category: "ai / tone & voice",
        status: "active",
        oneLiner: "one sentence in. five wildly different personalities out.",
        detail: "nyx is a small experiment in how easily personality can be manufactured through words. the same thought can sound confident, profound, chaotic, poetic or painfully polished — without changing what actually happened. it's exaggerated on purpose. a slightly ridiculous look at how differently we present ourselves depending on who we want to be.",
        tags: ["AI", "Writing", "Personality", "Satire"],
        href: "https://nyx.thewhizkind.com/"
      },
      sophos: {
        name: "sophos",
        category: "ai / learning platform",
        status: "work in progress",
        oneLiner: "a learning platform for teachers. a learning companion for students.",
        detail: "teachers can build courses, share materials, create assignments and bring learning into one place. for students, sophos goes a step further — using ai to understand what they're learning, support them when they're stuck and adapt to how they learn. online, in the classroom, or somewhere in between. sophos is still a work in progress — we're building, testing and learning as we go.",
        tags: ["Early Stage", "AI", "Education"]
      }
    },
    statuses: {
      active: "active",
      workInProgress: "work in progress"
    },
    cta: {
      title: "want to try one?",
      text: "we don't link these publicly — reach out and we'll give you something to play with."
    }
  },
  de: {
    hero: {
      eyebrow: "werkstatt / thewhizkind",
      title: "die <span>werkstatt</span>",
      intro: [
        "dinge, die wir mit menschen, teams und organisationen aufgebaut haben.",
        "einige lösen sehr spezifische probleme. einige automatisieren dinge, die nicht von hand erledigt werden sollten. einige entstanden einfach, weil wir uns gefragt haben: könnte das funktionieren?",
        "einige sind öffentlich zugänglich. einige nicht.",
        "mit einigen spielen wir. mit einigen arbeiten unsere partner tatsächlich."
      ]
    },
    transition: "experimente / werkzeuge / systeme / 01—∞",
    invite: {
      text: "neugierig auf eines? kontaktiere uns und wir geben dir etwas zum ausprobieren.",
      link: ["diese experimente ergänzen unsere", "dienstleistungen."]
    },
    index: {
      label: "dinge, die wir geschaffen haben.",
      mark: "+"
    },
    tools: {
      argus: {
        name: "argus",
        category: "internes werkzeug / daten / automatisierung",
        status: "aktiv",
        oneLiner: "um einen spezifischen arbeitsablauf herum aufgebaut, der echtwelt-daten in etwas leichter verständliches, verwaltbares und durchführbares verwandelt.",
        detail: "jeden monat musste jemand eine tabelle mit geldlichen forderungen manuell mit einem stapel von lastschrift-dokumenten abgleichen – zahlen zuordnen, unstimmigkeiten verfolgen, nach fehlendem suchen. argus liest die dokumente, gleicht sie zeile für zeile mit dem eintragsregister ab und gibt die gleiche datei zurück, bei der jede zeile geprüft ist. zugeschnitten auf einen echten, ungeordneten arbeitsablauf, während die kontrolle bei den menschen bleibt, die damit arbeiten.",
        tags: ["react", "node.js", "postgresql", "claude ai", "dokumentenextraktion"]
      },
      proba: {
        name: "proba",
        category: "bildung / bewertung / dashboard",
        status: "aktiv",
        oneLiner: "eine plattform, auf der tests absolviert werden können, bei der jede antwort direkt in ein modernes, interaktives dashboard fließt.",
        detail: "ein zeitlich begrenzter, fachlicher test im browser — abschnitte werden automatisch benotet, wo die antwort eindeutig ist, und für einen menschen markiert, wo dies nicht der fall ist. jede einreichung wird direkt in ein dashboard geschrieben, das sich scannen, filtern und bewerten lässt. die person, die bewertet, kann ergebnisse simultan einsehen, während die teilnehmenden aufgaben eingeben. die korrektur des stapels danach bleibt erspart.",
        tags: ["react", "vite", "dashboards", "auto-bewertung"]
      },
      fero: {
        name: "fero",
        category: "crm / finanzen / betriebswirtschaft",
        status: "aktiv",
        oneLiner: "ein crm- und finanz-werkzeug, das als eine plattform aufgebaut ist — finanzen, personal, verträge und vertrieb, in einem.",
        detail: "enthält die geschäftsbereiche eines kleinen unternehmens, die normalerweise in fünf verschiedenen anwendungen co-existieren und nicht vernetzt sind. rechnungsstellung und cashflow neben verträgen, neben dem team auf der gehaltsliste, neben der vertriebspipeline — alles an einem ort, aus einer einzigen quelle. entwickelt so, wie wir die meisten dinge entwickeln: ausgerichtet auf das, was ein kleines team tatsächlich braucht, und nicht auf das, was ein großes team vielleicht braucht.",
        tags: ["crm", "finanzen", "verträge", "personalwesen", "vertrieb"]
      },
      atlas: {
        name: "atlas",
        category: "internes werkzeug / lead-generierung / automatisierung",
        status: "aktiv",
        oneLiner: "ein internes system, um herauszufinden, was unsere aufmerksamkeit verdienen könnte.",
        detail: "atlas wurde rund um ein einfaches problem herum entwickelt: es gibt mehr möglichkeiten da draußen, als irgendjemand zeit hat, danach zu suchen. es übernimmt einen teil dieser suche für uns, rückt die interessanten näher heran und lässt den rest zurück.",
        tags: ["node.js", "postgresql", "claude ai", "automatisierung", "lead-generierung"]
      },
      vex: {
        name: "vex",
        category: "ki / personalisiert",
        status: "aktiv",
        oneLiner: "unsere eigene ki, die sich an dich anpasst.",
        detail: "die meisten ki-werkzeuge geben jedem denselben assistenten. vex ist darauf ausgelegt, auf den eigenen daten einer person oder eines unternehmens trainiert zu werden, sodass sie den kontext kennt, statt ihn erraten zu müssen — und so personalisiert ist, wie jemand tatsächlich arbeitet. der teil der werkstatt, der uns derzeit am herzen liegt.",
        tags: ["ki", "personalisierung"]
      },
      nyx: {
        name: "nyx",
        category: "ki / ton & stimme",
        status: "aktiv",
        oneLiner: "ein satz rein. fünf sätze mit völlig unterschiedlichen persönlichkeiten raus.",
        detail: "nyx ist ein kleines experiment darüber, wie einfach persönlichkeit durch worte vorgetäuscht werden kann. derselbe gedanke kann selbstbewusst, tiefgründig, chaotisch, poetisch oder schmerzhaft poliert klingen — ohne reale vorkommnisse zu verändern. hier wird absichtlich übertrieben. ein humorvoller blick auf unsere bereitschaft, uns für einen gewünschten zweck zu verstellen.",
        tags: ["ki", "schreiben", "persönlichkeit", "satire"],
        href: "https://nyx.thewhizkind.com/"
      },
      sophos: {
        name: "sophos",
        category: "ki / lernplattform",
        status: "in arbeit",
        oneLiner: "eine lernplattform für lehrkräfte. eine lernbegleitung für schülerinnen und schüler.",
        detail: "lehrkräfte können kurse erstellen, materialien teilen, aufgaben erstellen und das lernen an einem ort stattfinden lassen. für schülerinnen und schüler geht sophos einen schritt weiter — ki kommt zum einsatz, um zu verstehen, was sie lernen, sie zu unterstützen, wenn sie feststecken, und sich an ihre lernweise anzupassen. online, im klassenzimmer oder irgendwo dazwischen. sophos ist zum gegenwärtigen zeitpunkt noch in arbeit — wir bauen, testen und lernen dabei.",
        tags: ["frühstadium", "ki", "bildung"]
      }
    },
    statuses: {
      active: "aktiv",
      workInProgress: "in arbeit"
    },
    cta: {
      title: "möchtest du eines ausprobieren?",
      text: "wir verlinken diese nicht öffentlich — kontaktiere uns und wir geben dir etwas zum ausprobieren."
    }
  }
};

export default labTranslations;